import { useCallback } from 'react';
import { Dirary } from '../../types/dirary';
import Papa from 'papaparse';
const headers = [
  'レコード番号',
  '社員番号',
  '社員名',
  '部署ID',
  '所属工場ID',
  '役職コード',
  '作業開始日',
  '製作工場',
  '作業開始時間',
  '作業終了時間',
  '製作番号1',
  '製作番号2',
  '品番',
  'SN',
  'SOID',
  '号機',
  '表示名',
  '工程完了',
  '現場名',
  '伝票番号',
  '工程名',
  '工程ID',
  '予定工数',
  '作業時間(時間)',
  '作業時間(分)',
  '30分休憩',
  '当日合計作業時間(時間)',
  '当日合計作業時間(分)',
  'コメント',
  //夜勤2直対応: 末尾に4列追加(F4-3)。CSV列名は半角括弧(kintone/Firestoreの全角とは別)。
  '勤務区分',
  '開始時刻(テキスト)',
  '終了時刻(テキスト)',
  '日付またぎ',
  // "送信可能",
  // "無効",
];

const useCsvDownloader = () => {
  const downloadCsv = useCallback(
    (diaryList: Array<Dirary>, filename: string) => {
      const data = diaryList.map((diary) => ({
        レコード番号: diary.id,
        社員番号: diary.workerId,
        社員名: diary.workerName,
        部署ID: diary.departmentId,
        所属工場ID: diary.affiliationFactoryId,
        役職コード: diary.jobId,
        作業開始日: diary.workingDate,
        製作工場: diary.factoryId,
        作業開始時間: diary.startTime,
        作業終了時間: diary.endTime,
        製作番号1: diary.productNo,
        製作番号2: diary.productBno,
        品番: diary.itemsNumber,
        SN: diary.serialNumber,
        SOID: diary.soid,
        号機: diary.machineNumber,
        表示名: diary.displayName,
        工程完了: diary.isFinished,
        現場名: diary.siteName,
        伝票番号: diary.slipNumber,
        工程名: diary.processName,
        工程ID: diary.processId,
        予定工数: diary.estimatedTime,
        '作業時間(時間)': diary.workingTimeByHour,
        '作業時間(分)': diary.workingTimeByMinute,
        '30分休憩': diary.isBreak,
        '当日合計作業時間(時間)': diary.totalWorkingTimeByHour,
        '当日合計作業時間(分)': diary.totalWorkingTimeByMinute,
        コメント: diary.comment,
        //夜勤2直対応: 末尾4列(F4-3)。日付またぎはboolean素通し(既存30分休と同形式)。
        勤務区分: diary.shiftType,
        '開始時刻(テキスト)': diary.startTimeText,
        '終了時刻(テキスト)': diary.endTimeText,
        日付またぎ: diary.spansNextDay,
      }));
      // 現在の日時をYYYYMMDDHHMMSS形式で取得
      const now = new Date();
      //const jstOffset = 9 * 60; // UTC+9のオフセット（分）
      //now.setMinutes(now.getMinutes() + now.getTimezoneOffset() + jstOffset);
      // const timestamp = now.toISOString().replace(/[-:T]/g, "").slice(0, 14);
      const timestamp = formatDateForFilename(now);
      const fullname = `${filename}_${timestamp}.csv`;

      // CSVデータを変換
      const bom = '\uFEFF'; // BOMの追加
      const csv = bom + Papa.unparse({ fields: headers, data });

      // Blobを使ってCSVファイルを作成
      const csvFile = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      // ダウンロード用のリンクを作成
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(csvFile);
      downloadLink.setAttribute('download', fullname);
      // リンクをクリックしてダウンロードを実行
      document.body.appendChild(downloadLink); // DOMにリンクを追加
      downloadLink.click(); // リンクをクリック
      document.body.removeChild(downloadLink); // リンクを削除
    },
    []
  );

  return { downloadCsv };
};

const formatDateForFilename = (date: Date) => {
  if (!date) return '';

  const d = new Date(date);
  const year = d.getFullYear();
  const month = `0${d.getMonth() + 1}`.slice(-2);
  const day = `0${d.getDate()}`.slice(-2);
  const hour = `0${d.getHours()}`.slice(-2);
  const minute = `0${d.getMinutes()}`.slice(-2);
  const second = `0${d.getSeconds()}`.slice(-2);

  return `${year}${month}${day}_${hour}${minute}${second}`;
};

export default useCsvDownloader;
/*
data = [
  [
    { id: 1, name: "aaa", value: 20 },
    { id: 3, name: "b", value: 20 },
    { id: 2, name: "aaa", value: 20 },
  ],
  [
    { id: 1, name: "aaa", value: 20 },
    { id: 3, name: "daa", value: 40 },
    { id: 2, name: "aaa", value: 20 },
  ],
  [
    { id: 1, name: "ff", value: 40 },
    { id: 3, name: "aea", value: 20 },
    { id: 2, name: "aaa", value: 20 },
  ],
];
header = [{ columnId: "ID", isShow: true }];
input =[[{"ID":"11111" },{name:"maeda"}],[{"ID":"12345" },{name:"hayashi"}]]
output =[["11111","maeda"],[12345,"hayashi"]]
*/
